module.exports = __webpack_public_path__ + "static/media/hams-hall-map.3dbc28d7.png";